module.exports = __webpack_public_path__ + "img/殷文聪.2e72621c.jpg";